import { AiPreviewResponse } from './types';
import { axiosClient } from '../axiosClient';

type Options = {
  type?: 'set-ai' | 'intent-ai';
  prompt: string;
  param1?: string;
};

export const setAiPreview = ({ type = 'set-ai', prompt, param1 }: Options) => {
  return axiosClient.post<AiPreviewResponse>('/ai-preview', {
    type,
    question: prompt,
    param1,
  });
};
